import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { GridRow, Column, MoneyField } from '../../common';

const FECSection6b = ({ cashOnHandAtBeginning }) => {
  return (
    <Fragment>
      <GridRow>
        <Column md={4} classNames="sub-question">
          <p>
            (b) Cash on Hand at
            <br />
            Beginning of Reporting Period
          </p>
        </Column>
        <Column md={4} classNames="entry-row">
          <MoneyField
            disabled
            value={cashOnHandAtBeginning || 0}
          />
        </Column>
      </GridRow>
    </Fragment>
  );
};

FECSection6b.propTypes = {
  q6bColA: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FECSection6b;
